
import { getInfo, getUserToken } from "@/api/login";
import { Message, Loading } from 'element-ui';
import store from '@/store';
// 存储token和用户信息
export async function storeTokenAndUserInfo(query) {
    let token = '';
    if (query.uuid) {
        window.isH5 = true;
        const { data } = await getUserToken(query.uuid);
        token = 'Bearer ' + data.accessToken
    }
    token = token ? token : query.token
    localStorage.setItem('key_user_token', JSON.stringify(token));
    const { code, data, msg } = await getInfo();
    if (code == 0) {
        localStorage.setItem('store-user-info', JSON.stringify({ userInfoState: data }));
        store.commit('imWorkbench/setUserId', localStorage.getItem("store-user-info") ? JSON.parse(localStorage.getItem("store-user-info")).userInfoState.userId : "")
    } else {
        Message.error(msg);
    };
}


export default (router) => {
    // 全局前置守卫
    router.beforeEach(async (to, from, next) => {
        let loadingInstance = '';
        let token = localStorage.getItem('key_user_token');
        if ((to.query.uuid || to.query.token) && !token) {
            loadingInstance = Loading.service({ text: '正在登录...' });
            await storeTokenAndUserInfo(to.query);
        }
        // next(); // 继续导航
        setTimeout(() => {
            if (loadingInstance) {
                loadingInstance.close();
            }
            next(); // 继续导航
        }, window.isH5 ? 2000 : 0);
    })

    return router
}